module.exports = __webpack_public_path__ + "31491f2233d85b9fd7f7e99f29fec543.svg";